const translation = {
  offRules: 'Официальные Правила',
  // Navigation pages
  play: 'ИГРАТЬ',
  recent: 'Недавние',
  howToPlay: 'КАК ИГРАТЬ',

  // Card
  signUp: 'ВОЙТИ ДЛЯ ИГРЫ',
  viewMy: 'СМОТРЕТЬ МОЮ КАРТУ',
  view: 'СМОТРЕТЬ КАРТУ',
  registered: 'ЗАРЕГИСТРИРОВАН',
  entry: 'Участник',
  entries: 'Участники',
  contestClosed: 'СОРЕВНОВАНИЕ BINGO ЗАКРЫТО',
  ifNecessary: 'ЕСЛИ НЕОБХОДИМО',

  //Signup modal
  reg: 'Вы зарегистрированы для игры в OlyBet Bingo',
  rel: 'Ваша карта Bingo будет раскрыта через:',
  come: 'Для просмотра своей карты возвращайтесь к началу игры',
  priz: 'Призы',
  regen: 'КАРТА BINGO АВТОМАТИЧЕСКИ ОБНОВЛЯЕТСЯ ВО ВРЕМЯ ИГРЫ',
  //Wait modal
  hangTight: 'ПРОДОЛЖАЙТЕ!',
  cardToBeGenerated: 'Ожидание создания КАРТЫ BINGO.',
  mayTakeUpFewMinutes: 'ЭТО МОЖЕТ ЗАНЯТЬ ДО НЕСКОЛЬКИХ МИНУТ',

  // How to play page
  vert: 'ВЕРТИКАЛЬ',
  horiz: 'ГОРИЗОНТАЛЬ',
  diag: 'ДИАГОНАЛЬ',
  fullCard: 'ВСЯ КАРТА',
  earnEntriesIntoDraw:
    'ЗАРАБАТЫВАЙТЕ ПРИЗЫ ПРИ ЗАПОЛНЕНИИ ЦЕЛОГО РЯДА, ДИАГОНАЛИ ИЛИ ВСЕЙ КАРТЫ. СЕКТОР БУДЕТ УЧТЁН, ЕСЛИ ОТМЕЧЕННОЕ В НЁМ СОБЫТИЕ СОСТОЯЛОСЬ.',
  autoScoresDuringGame: 'КАРТА BINGO АВТОМАТИЧЕСКИ ОБНОВЛЯЕТСЯ ВО ВРЕМЯ ИГРЫ',
  clickForMoreInfo: 'Для получения подробной информации нажмите на',
  SOG: 'SOG – Бросок в створ ворот (любой бросок, засчитанный как бросок в створ ворот. Не включает блокированные или попавшие в штангу броски)',
  PPG: 'PPG – Гол в большинстве (гол, забитый командой, играющей с преимуществом в составе. Например, команда, которая играет с преимуществом в 5v4, 5v3 или 4v3)',
  SHG: 'SHG – Гол в меньшинстве (гол, забитый командой, игрок которой отбывает пенальти)',
  PIM: 'PIM – Штрафы в минутах',
  FOPercent: 'FO% — Процент вбрасываний',
  PTS: 'PTS – Очки (гол или результативная передача)',
  entryPerRow: 'УЧАСТНИК НА РЯД',
  totalEntries: 'ОБЩЕЕ КОЛ-ВО УЧАСТНИКОВ',
  perRow: 'НА РЯД',

  //Home page
  bingoMayTakeUp:
    'Подтверждение результатов карты Bingo может занять до 20 минут после завершения игры',
  welcomeTo: 'Добро пожаловать в BingOly!',
  reviewInRecent: 'Смотрите свои последние карты во вкладке «Недавние»',
  thanksForPlaying:
    'Благодарим за участие в OlyBet Bingo! Смотрите свои карты за сезон 2022-2023 во вкладке «Недавние»',
  agreeToRules:
    'Регистрируясь, Вы подтверждаете, что ознакомились и соглашаетесь с',

  //Recent page
  noRecentContests: 'Нет недавних игр',
  //Game field page
  gamePrizeText:
    'Выиграйте 100 € Фрибет, если заполните все секторы на своей карте, или 5 € Фрибет, если Вам удастся собрать хотя бы один ряд или диагональ. Призы будут зачислены в рабочие часы.',
  cardUpdateAfterPeriod: 'Карта обновляется каждые 30 минут',
  anyLine: 'ЛЮБАЯ ЛИНИЯ',
  vertLines: 'ВЕРТИКАЛЬНЫЕ ЛИНИИ',
  line: 'ЛИНИЯ',
  horzLines: 'ГОРИЗОНТАЛЬНЫЕ ЛИНИИ',

  //Onboarding page
  letsGetStarted: 'Давайте начнём!',
  makeSureToEnterSelections:
    'Не забывайте вносить свои ответы каждый день для получения ежедневных призов. Не забудьте указать вопрос тай-брейкера до подтверждения своего выбора. Вы можете изменить свой выбор до начала игры. Зарабатывайте очки за каждый правильно сделанный прогноз.',
  playWithFriends:
    'Играйте с друзьями. Кто знает больше? Сразитесь в игре против своих друзей в приватной лиге. Перейдите в раздел таблицы лидеров, нажмите на кнопку Создать для начала и поделитесь PIN-кодом, чтобы Ваши друзья присоединились.',
  scoring: 'Подсчёт очков',
  challengeFriends: 'Бросьте вызов друзьям',
  skip: 'пропустить',
  next: 'далее',

  logout: 'Выйти',
  returnToGamezone: 'Вернуться в Игровую зону',
  rules: 'ПРАВИЛА',
  back: 'Назад',

  bingo: 'BingOly',
  gamezone: 'Игровая зона',
  justAFewMinutes: 'Всего несколько минут, пожалуйста, обновите страницу',
  fourCorners: 'ЧЕТЫРЕ УГЛА',
  rulesNotFound: 'Правила не найдены',
  offWebsiteText:
    'ОФИЦИАЛЬНЫЙ ВЕБ-САЙТ СОБЫТИЯ БУДЕТ СЧИТАТЬСЯ ОСНОВНЫМ ИСТОЧНИКОМ РЕЗУЛЬТАТОВ. ЕСЛИ ОН НЕДОСТУПЕН, ТО БУДУТ ИСПОЛЬЗОВАТЬСЯ ДРУГИЕ НАДЁЖНЫЕ ИСТОЧНИКИ ИЛИ ПРОСМОТР ВИДЕО.',
  accountInfo: 'Информация аккаунта',
  availableGames: 'Доступные игры',
  backToOlybet: 'Назад в OlyBet',
  confirmNewPassword: 'Подтвердить новый пароль',
  confirmNewPasswordIsRequired:
    'Подтвердить новый пароль обязательно для заполнения',
  confirmPassword: 'Подтвердить пароль',
  confirmPasswordIsRequired: 'Confirm Password is a required field',
  contactNumber: 'Контактный номер',
  country: 'Страна проживания',
  countryIsRequired: 'Страна обязательна для заполнения',
  days: 'Дни',
  didNotMeanToUnsubscribe: 'Не хотел отписываться?',
  email: 'Э-почта',
  emailAddressAlreadyInUse: 'Адрес э-почты уже использован',
  emailIsRequired: 'Адрес э-почты обязателен для заполнения',
  emailOrUsername: 'Э-почта или имя пользователя',
  emailOrUsernameIsRequired:
    'Э-почта или имя пользователя обязательны для заполнения',
  enterYourDetails: 'Пожалуйста, укажите свои данные ниже',
  enterYourEmail: 'Укажите свою э-почту для восстановления пароля',
  errorDuringLogin: 'Ошибка при логине',
  errorDuringRegistration: 'Ошибка при регистрации',
  errorDuringSubscribing: 'Error during subscribing',
  errorDuringUnsubscribing: 'Ошибка при отмене подписки',
  errorUpdatingProfile: 'Ошибка при обновлении профиля',
  firstName: 'Имя',
  firstNameIsRequired: 'Имя обязательно для заполнения',
  firstNameMusBeAtLeast: 'Имя должно содержать не менее 3 символов',
  firstNameMustNotExceed: 'Имя не может превышать 100 символов',
  forgotPassword: 'Забыл пароль',
  full: 'ПОЛНЫЙ',
  gameDetails: 'Детали игры',
  getResetLink: 'Получить ссылку на восстановление',
  goodbye: 'До свидания!',
  inappropriateWordsNotAllowed: 'Неэтичные слова и фразы запрещены',
  informationAndPromotionalAgreement:
    'Я согласен получать информацию и рекламные предложения от OlyBet по указанным здесь контактным данным. Я могу отозвать согласие в любое время, нажав на ссылку в нижней части рекламного сообщения. Более подробная информация об обработке данных доступна в Уведомлении об обработке личных данных.',
  inOrderToPlayAndRedeemPrizes:
    'Для игры и получения призов Ваши данные должны быть корректными и подтвержденными. Некоторые призы будут выплачены на аккаунт OlyBet, поэтому для получения этих призов Ваши данные должны совпадать с теми, что указаны в OlyBet (имя и э-почта).',
  invalidCredentials: 'Неправильные данные',
  invalidEmailFormat: 'Invalid email format',
  itIsRequiredField: 'Это обязательное поле',
  joinNow: 'Присоединиться сейчас',
  lastName: 'Фамилия',
  laststNameIsRequired: 'Фамилия обязательна для заполнения',
  laststNameMusBeAtLeast: 'Фамилия должна содержать не менее 3 символов',
  laststNameMustNotExceed: 'Фамилия не может превышать 100 символов',
  legalConsent: 'Согласие с юридическими документами',
  lines: 'ЛИНИИ',
  live: 'LIVE',
  liveGames: 'Live-игры',
  login: 'Login',
  marketingConsent: 'Согласие на получение рекламы',
  mobileNumber: 'Номер моб. телефона',
  mobileNumberIsRequired: 'Номер моб. телефона обязателен для заполнения',
  mobileNumberMustBeAtLeast:
    'Номер моб. телефона должен содержать не менее 6 символов',
  mobileNumberMustNotExceed:
    'Номер моб. телефона не может превышать 15 символов',
  mustBeChecked: 'Подлежит проверке',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  myContest: 'Мои соревнования',
  myHistory: 'Моя история',
  nationality: 'Национальность',
  newPassword: 'Новый пароль',
  newPasswordIsRequired: 'Новый пароль обязателен для заполнения',
  nickname: 'Никнейм',
  nicknameAlredyInUse: 'Никнейм уже использован',
  nicknameIsRequired: 'Никнейм обязателен для заполнения',
  noHistoryYet: 'История отсутствует',
  noUpcomingContestsYet: 'Нет предстоящих событий',
  oops: 'Ой! Что-то пошло не так...',
  over$PrizeValueWon: 'Over <1>$1,000,000</1> prize value won',
  password: 'Пароль',
  passwordDoNotMatch: 'Пароли не совпадают',
  passwordIsRequired: 'Пароль обязателен для заполнения',
  passwordNotMeetCriteria: 'Пароль не соответствует требованиям',
  passwordSuccessfullyReset: 'Пароль успешно обновлён',
  personalDetails: 'Персональные данные',
  playNow: 'Играть сейчас',
  pleaseCheckYourEmailInbox: 'Пожалуйста, проверьте почтовый ящик',
  pos: 'Позиция',
  preferences: 'Предпочтения',
  profile: 'Профиль',
  pts: 'Очки',
  recentWinners: 'Недавние победители',
  region: 'Регион',
  resetLinkSent:
    'Ссылка на восстановление пароля успешно отправлена на Вашу э-почту',
  resetPassword: 'Восстановить пароль',
  resubscribe: 'Подписаться снова',
  returnToLogin: 'Return to login',
  saveChanges: 'Сохранить изменения',
  signIn: 'Логин',
  success: 'Получилось!',
  successfullyLoggedIn: 'Вы успешно вошли',
  successfullySentResetLink: 'Successfully sent reset link to your email',
  successfullySignedUp: 'Регистрация успешно завершена!',
  successfullySubscribed: 'Successfully subscribed',
  successfullyUnsubscribed: 'Подписка успешно отменена',
  successfullyUpdatedProfile: 'Профиль успешно обновлён',
  unsubscribe: 'Отписаться',
  upload: 'Загрузить',
  username: 'Имя пользователя',
  usernameAlreadyInUse: 'Уже зарегистрированы?',
  usernameIsRequired: 'Username is a required field',
  veryStrongPassword: 'Very strong password',
  welcomeBack: 'С возвращением!',
  win: 'ПОБЕДА',
  winner: 'Победитель',
  youHaveSuccesfullyUnsubscribed: 'Вы успешно отписались от рассылки OlyBet.',
  yourEmail: 'Your email',
  youWishToUnsubscribe:
    'Если Вы уверены, что хотите отписаться от рассылки OlyBet, пожалуйста, нажмите ниже.',
  zipCode: 'Почтовый индекс',
  zipCodeIsRequired: 'Почтовый индекс обязателен для заполнения',
  zipCodeMustBeAtLeast: 'Почтовый индекс должен содержать не менее 3 символов',
  zipCodeMustNotExceed: 'Почтовый индекс не может превышать 100 символов',
};
export default translation;
